import { AxiosResponse } from "axios";
import { Axios } from "../Axios";
import { TypeTelefoneTipo } from "../../Models/Pessoa/Contato/Telefone";

export class TelefoneService {
    public listarTiposTelefones(): Promise<AxiosResponse<TypeTelefoneTipo[]>>{
        return Axios.get<TypeTelefoneTipo[]>(`Telefone/listarTiposTelefones`);
    }

}